/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const STORE = 'STORE'
export const STORE_PERMISSIONS = 'STORE_PERMISSIONS'
export const UPDATE = 'UPDATE'
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'

export default {
  STORE_PERMISSIONS,
  UPDATE_PERMISSIONS,
  UPDATE,
}



// WEBPACK FOOTER //
// ./src/store/modules/account/mutation-types.js